import { render, staticRenderFns } from "./EstimageMessageViewSideMenu.vue?vue&type=template&id=1d3b54c4"
import script from "./EstimageMessageViewSideMenu.vue?vue&type=script&lang=js"
export * from "./EstimageMessageViewSideMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports